import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const formControlLabelStyles = (printOption: string, value: string) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '4px',
  color: paletteBase.black,
  margin: 0,
  '& .MuiTypography-root': {
    fontWeight: printOption === value ? 500 : 400,
  },
  '& .MuiRadio-root': {
    padding: 0,
  },
});

export const radioGroupStyling: AbgSxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};

export const radionOptionStyling: AbgSxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

export const textBlock: AbgSxProps = {
  margin: 0,
  padding: 0,
};

export const actionButtonStyle: AbgSxProps = {
  width: {
    md: 'auto',
    xs: '100%',
    sm: 'auto',
  },
};
